import './App.css';
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Router from './routes/Router'
import installAxiosInterceptors from './services/axiosSetup';

installAxiosInterceptors();


function App() {
  return (
    <div className="App flex">
      <BrowserRouter>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: { fontSize: "14px" },
            success: { iconTheme: { primary: "#16a34a", secondary: "#fff" } },
            error: { iconTheme: { primary: "#dc2626", secondary: "#fff" } },
          }}
        />
        <div className="flex-grow">
          <Router/>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
